import _get from 'lodash/get';
import { gdprCookies } from '@bedrock-rdk/config';

/**
 * Checks if user preferences contains any rejected category and returns an array of those categories
 *
 * @param {string[]} consentCategories different cookie consent categories: "tracking", "advertizing", etc.
 * @param {Object} userPreferences and object keys of which represent consent categories and values corresponds to consent or rejection
 * @returns {string[]} rejected consent categories
 */
export const getRejectedConsents = (consentCategories, userPreferences) =>
  consentCategories ? consentCategories.filter(consent => _get(userPreferences, [consent]) === false) : [];

export const setAllCookies = value => gdprCookies.reduce((cookies, cookie) => ({ ...cookies, [cookie]: value }), {});

export const areCookiesEmpty = cookies =>
  cookies ? Object.values(cookies).some(cookie => typeof cookie !== 'boolean') : true;
